export const module_tabs = [
    { name: 'view', value: 'Screens' },
    { name: 'model', value: 'Data Attributes' },
    { name: 'method', value: 'Data Access' },
];
export const group_columns = [
    { title: 'Name', dataIndex: 'name', _id: 'name' },
    { title: 'Access', dataIndex: 'access', _id: 'access' },
];
export const crud_options = [
    { title: 'Create', status: '' },
    { title: 'Read', status: '' },
    { title: 'Update', status: '' },
    { title: 'Delete', status: '' },
];
export const proxy = {
    view: 'views',
    model: 'models',
    method: 'classMethods',
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/statics.js